<template>
  <div class="project-manage">
    <div class="add-project">
      <div class="screen">
        <el-select class="white w200" clearable v-model="screen.warehouseId" placeholder="请选择仓库">
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input class="white w240" v-model="screen.name" placeholder="请输入项目名称"></el-input>
        <el-select class="white w200" clearable v-model="screen.status" placeholder="请选择项目状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
        <el-button class="btn-blue" @click="onScreen">搜索</el-button>
      </div>
      <div class="operation-btn">
        <el-button class="btn-white" @click="openExcel"
          >导入</el-button
        >
        <el-button class="btn-blue add-btn" @click="openProjectDialog">+新增</el-button>
      </div>
    </div>
    <div class="table">
      <el-table
        ref="table"
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="warehouseName" label="仓库" min-width="140"></el-table-column>
        <el-table-column prop="customerName" label="客户名称" min-width="300"></el-table-column>
        <el-table-column prop="ordersName" label="客户简称" min-width="200"></el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="140"></el-table-column>
        <el-table-column prop="head" label="负责人" min-width="140"></el-table-column>
        <el-table-column label="操作" min-width="138">
          <template slot-scope="scope">
            <el-button
              class="btn-text"
              :disabled="scope.row.status!==1"
              type="text"
              @click="updateProject(scope.row.id)"
            >编辑</el-button>
            <el-button
              class="btn-text"
              :disabled="scope.row.status!==1"
              type="text"
              @click="seeProjectDetail(scope.row.id)"
            >详情</el-button>
            <el-button
              class="btn-text"
              type="text"
              v-if="scope.row.status===1"
              @click="closeProject(scope.row.id)"
            >关闭</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <!-- <el-button type="text" class="btn-text" @click="openCustomerDialog">新增客户</el-button> -->
      <pagination-tpl
        :total="total"
        :currentPage="currentPage"
        :pageSize="pageSize"
        @queryChange="queryChange"
      ></pagination-tpl>
    </div>
    <!-- 新增客户 -->
    <el-dialog title="新增客户" top="35vh" :visible.sync="customerDialog" width="420px">
      <div class="border"></div>
      <p class="error-message" v-show="customerForm.errorMeaasge">{{ customerForm.errorMeaasge }}</p>
      <el-form
        ref="customerForm"
        :rules="customerFormRules"
        :model="customerForm"
        label-width="80px"
      >
        <el-form-item label="客户名称：" prop="name">
          <el-input v-model="customerForm.name" class="white"></el-input>
        </el-form-item>
        <el-form-item label="客户简写：" prop="abbreviation">
          <el-input v-model="customerForm.abbreviation" class="white"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="addCustomer('customerForm')">确定</el-button>
      </div>
    </el-dialog>

    
    <!-- 实占面积导入 -->
    <el-dialog title="实占面积导入" top="20vh" :visible.sync="promptingDialog" width="420px" :before-close="closeOrderDown">
      <div class="border"></div>
      <div>
        <div>
          <i class="el-icon-warning"></i>
          <span class="sub-title introduce">功能介绍</span>
        </div>
        <p class="tips">导入客户实占面积，算得场租费用</p>
      </div>
      <div class="down-tmp">
        <div class="sub-title">
          <span>下载导入模板</span>
          <span class="sub-tips">(点击下载)</span>
        </div>
        <el-button type="text" class="btn-text" @click="downTmp">实占面积导入模板.xlsx</el-button>
      </div>
      <div>
        <p class="sub-title">实占面积导入</p>
        <el-upload
          v-if="isUpload"
          v-loading.fullscreen.lock="loading3"
          element-loading-text="文件上传中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          class="upload"
          ref="upload"
          action="#"
          :show-file-list="false"
          :auto-upload="true"
          :before-upload="uploadExcel"
        >
          <el-button slot="trigger" type="text" class="btn-text"
            >{{uploadTipsName}}</el-button
          >
        </el-upload>
        <div v-else class="upload-tips-container">
          <div class="upload-tips-name">
            {{uploadTipsName}}
            <i class="el-icon-error" @click="removeUploadOrder"></i>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeOrderDown"
          >取消</el-button
        >
        <el-button class="btn-blue" @click="confirmOrderDown"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
import ProjectManage from "models/project-manage";
const expenses = new Expenses();
const projectManage = new ProjectManage();
import { downLoadFile, modifyNetTitle } from "common/js/util";
export default {
  data() {
    return {
      screen: {
        warehouseId: "",
        name: "",
        status
      },
      screenValue: {
        warehouseId: "",
        name: "",
        status
      },
      statusList: [
        {
          id: 0,
          name: "关闭"
        },
        {
          id: 1,
          name: "开启"
        }
      ],
      tableData: [], //项目列表
      total: 0,
      currentPage: 1,
      pageSize: 20,
      customerDialog: false,
      customerForm: {
        errorMeaasge: "",
        name: "",
        abbreviation: ""
      },
      customerFormRules: {
        name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        abbreviation: [
          { required: true, message: "请输入客户简写", trigger: "blur" }
        ]
      },
      warehouseList: [],
      loading3: false,
      promptingDialog: false,
      uploadTipsName: '点击导入',
      /* wms订单导入的流 */
      formData: null,
      /* 是否导入 */
      isUpload: true,
    };
  },
  components: {
    PaginationTpl
  },
  watch: {
    customerDialog: {
      handler(value) {
        if (!value) {
          this.customerForm.errorMeaasge = "";
          this.customerForm.name = "";
          this.customerForm.abbreviation = "";
        }
      }
    }
  },
  created() {
    modifyNetTitle('电商仓项目列表')
    this.getWarehouse();
    this.getTableData();
  },
  methods: {
    tableRowClassName({ row }) {
      if (row.status !== 1) {
        return "close-row";
      }
    },
    //获取仓库数据
    getWarehouse() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },
    //获取电商仓项目
    getTableData() {
      let currentPage = this.currentPage;
      let warehouseId = this.screenValue.warehouseId;
      let projectName = this.screenValue.name;
      let status = this.screenValue.status;
      projectManage
        .getProjectList(currentPage, warehouseId, projectName, status)
        .then(res => {
          if (res.success) {
            let tableData = [];
            this.pageSize = res.result.pageSize;
            this.total = res.result.totalNum;
            res.result.items.map(value => {
              let obj = {};
              obj.id = value.id;
              obj.warehouseName = value.warehouseName;
              obj.status = value.status;
              obj.customerName = value.customerName;
              obj.ordersName = value.ordersName;
              obj.projectName = value.projectsName;
              obj.head = value.employeeName;
              tableData.push(obj);
            });
            this.tableData = tableData;
          }
        });
    },
    onScreen() {
      this.screenValue = this.screen;
      this.currentPage = 1;
      this.getTableData();
    },
    openProjectDialog() {
      this.$router.push({
        path: '/base-info/project-manage/project-list/add-project',
        query: {
          isFlag: 1
        }
      })
    },
    openCustomerDialog() {
      this.customerDialog = true;
    },
    closeDialog() {
      this.customerDialog = false;
    },
    //编辑项目
    updateProject(id) {
      this.$router.push({
        path: '/base-info/project-manage/project-list/add-project',
        query: {
          projectId: id,
          isFlag: 2
        }
      })
    },
    //查看项目详情
    seeProjectDetail(id) {
      this.$router.push({
        path: '/base-info/project-manage/project-list/add-project',
        query: {
          projectId: id,
          isFlag: 3
        }
      })
    },
    //关闭项目
    closeProject(id) {
      this.$confirm("是否确定永久关闭该项目?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        projectManage.getCloseProject(id).then(res => {
          if (res.success) {
            this.getTableData();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    //新增客户
    addCustomer(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.name = this.customerForm.name;
          data.ordersName = this.customerForm.abbreviation;
          projectManage.postAddCustomer(data).then(res => {
            if (res.success) {
              this.closeDialog();
              this.customerForm.errorMeaasge = "";
            } else {
              this.customerForm.errorMeaasge = res.message;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //翻页
    queryChange(data) {
      this.currentPage = data.currentPage;
      this.getTableData();
    },
    downTmp() {
      let url = 'https://xinge-kz.oss-cn-hangzhou.aliyuncs.com/oa/template/%E5%AE%9E%E5%8D%A0%E9%9D%A2%E7%A7%AF%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx'
      downLoadFile('实占面积导入模板',url)
    },
    closeOrderDown() {
      this.removeUploadOrder()
      this.promptingDialog = false
    },
    confirmOrderDown() {
      if (this.isUpload) {
        return this.$message.error("请导入文件");
      }
      projectManage
        .postExcel(this.formData)
        .then(res => {
          if (res.success) {
            this.$message.success("导入成功");
            this.closeOrderDown()
          } else {
            this.$confirm(res.message, "提示", {
              showCancelButton: false,
              confirmButtonText: "确定",
              type: "warning"
            }).then(() => {});
          }
        })
        .catch(res => {
          this.$message.error("导入失败");
        });
    },
    removeUploadOrder() {
      this.formData = null
      this.uploadTipsName = '点击导入'
      this.isUpload = true
    },
    //导入Excel表格
    uploadExcel(file) {
      var formData = new FormData();
      formData.append("file", file);
      this.formData = formData
      this.uploadTipsName = file.name
      this.isUpload = false
      return false;
    },
    openExcel() {
      this.promptingDialog = true
    }
  }
};
</script>
<style lang="scss" scoped>
.project-manage {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 16px;
  box-sizing: border-box;
  .add-project {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .screen {
      display: flex;
      .w200 {
        width: 200px;
        margin-right: 16px;
      }
      .w240 {
        width: 240px;
        margin-right: 16px;
      }
      /* .el-input {
        margin: 0 16px;
        width: 280px;
      } */
    }
    .operation-btn {
      display: flex;
      .add-btn {
        margin-left: 20px;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 16px;
  }
  .el-dialog {
    .label1 {
      color: #999999;
      padding-bottom: 10px;
    }
    .label2 {
      color: #999999;
      padding-bottom: 16px;
    }
    .el-form {
      padding: 0 30px 0 10px;
      .el-select {
        width: 100%;
      }
      .el-date-editor {
        width: 100%;
      }
      .price {
        display: inline-block;
        position: absolute;
        width: 40px;
        color: #cdcccc;
        right: 0;
      }
    }
    .projectForm {
      height: 500px;
      overflow: auto;
    }
    .dialog-footer {
      margin-top: 16px;
      border-top: 1px solid #f7f7f7;
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
    .detail-list {
      padding: 0 20px;
      height: 400px;
      overflow: auto;
      li {
        line-height: 32px;
        .labal {
          display: inline-block;
          width: 100px;
          text-align: right;
          color: #999999;
        }
      }
    }
    .error-message {
      padding-left: 20px;
      padding-bottom: 5px;
      font-size: 12px;
      color: #f56c6c;
    }
  }
}
</style>
<style lang="scss">
.project-manage {
  .table .el-table .el-table__body-wrapper .el-table__body .close-row td .cell {
    color: #b7b7b7;
    .el-button.btn-text {
      color: #b7b7b7;
      font-size: 14px;
    }
  }
  .el-dialog {
    .el-form {
      .el-form-item__content {
        height: 32px;
        display: flex;
        align-items: center;
        .el-radio {
          margin-right: 10px;
          .el-radio__label {
            padding-left: 5px;
          }
        }
      }
    }
  }
  
  .down-tmp {
    margin-bottom: 8px;
  }
  .el-icon-warning {
    font-size: 16px;
    color: #F47A25;
    margin-right: 6px;
    vertical-align: middle;
  }
  .sub-title {
    font-size: 14px;
    font-weight: 400;
    color: #333333;
  }
  .introduce {
    display: inline-block;
  }
  .tips {
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    margin: 11px 0px 21px 0px;
  }
  .upload-tips-container {
    position: relative;
    width: 180px;
    .upload-tips-name {
      height: 30px;
      line-height: 30px;
      margin: 12px 0px;
      color: #2E68EA;
      background: #EBEEF5;
      border-radius: 2px;
      padding-left: 7px;
      box-sizing: border-box;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      .el-icon-error {
        position: absolute;
        top: -5px;
        right: -8px;
        color: #999999;
        cursor: pointer;
      }
    }
  }
  .sub-tips {
    color: #999999;
  }
  .dialog-footer {
    margin-top: 16px;
    border-top: 1px solid #f7f7f7;
    padding-top: 16px;
    display: flex;
    justify-content: center;
    .btn-white {
      margin-right: 20px;
    }
  }
}
</style>
